import React from "react";
import { Form } from "antd";
import ShopType from "@/enum/ShopType";
import OrderTagSelect from "../OrderTagSelectField/OrderTagSelect";

interface OrderTagSelectFieldProps {
    shopType?: ShopType;
}

/** 不含标签 */
const OrderTagUnSelectField: React.FC<OrderTagSelectFieldProps> = (props) => {
    const { shopType } = props;

    return (
        <Form.Item name="excludedOrderTags" label={<span className="search-field-label">不含标签</span>}>
            <OrderTagSelect shopType={shopType} />
        </Form.Item>
    );
};

export default React.memo(OrderTagUnSelectField);
